export default __webpack_public_path__ + "static/media/multimedia.1aa255d3.svg";